import request from './axiosFun';
import apiLogin from './apiLogin';

var url = ''
if (process.env.NODE_ENV === "development") {
  url = '/est'
} else {
  url = ''
}

// 屠宰场列表

export function getButcherBeanList(query) {
  return request({
    url: url + '/butcher/butcherdetail/getButcherBeanList',
    method: 'post',
    data: query

  })
}

// 屠宰场详情
export function getButcherLockBeanList(query) {
  return apiLogin({
    url: url + '/butcher/butcherdetail/getButcherLockBeanList',
    method: 'post',
    data: query
  })
}

// 查询区域地址

export function selectByAreas(query) {
  return request({
    url: url + '/pasture/sys/selectByAreas',
    method: 'post',
    data: query

  })
}

// 通道列表
export function recordList(query) {
  return request({
    url: url + '/butcher/butcherdetail/getButcherCountBeanList',
    method: 'post',
    data: query

  })
}

// 所有屠宰场下的所有通道
export function getButcherAndLockList(query) {
  return request({
    url: url + '/butcher/butcherdetail/getButcherAndLockList',
    method: 'post',
    data: query
  })
}

// // 所有屠宰场下的所有通道
// export function getButcherBeanList(query) { // 新
//   return request({
//     url: url + '/butcher/butcherdetail/getButcherBeanList',
//     method: 'post',
//     data: query
//   })
// }

// 开门
export function oppDoor(query) {
  return request({
    url: `${url}/butcher/door/oppDoor?controllerSN=${query.controllerSN}&doorNO=${query.doorNO}&IP=${query.IP}&port=${query.port}`,
    method: 'get'
  })
}

// 订单详情
export function recordDetail(query) {
  return request({
    url: url + '/api/butchter/getOrdersDetail?orderNum=' + query.orderNum,
    method: 'get',
    platFlag: 'notoken'

  })
}

export function findDictList(query) {
  return request({
    url: url + '/base-server/homeCenter/sysInfo/findDictList',
    method: 'post',
    data: query
  })
}
//
export function getButcherOrderCountBeanList(query) {
  return request({
    url: url + '/butcher/butcherdetail/getButcherOrderCountBeanList',
    method: 'post',
    data: query
  })
}
// 修改价格
export function updLockPriceOrAnotherName(query) {
  return request({
    url: url + '/butcher/butcherlock/updLockPriceOrAnotherName',
    method: 'post',
    data: query
  })
}
// 查询资质信息
export function queryUserCertFileList(query) {
  return request({
    url: url + '/pasture/tUserCertFile/queryUserCertFileList',
    method: 'post',
    data: query
  })
}



// WEBPACK FOOTER //
// ./src/api/slaughter.js